__turbopack_context__.v({
  "bottomContainer": "IMC7nq_bottomContainer",
  "container": "IMC7nq_container",
  "disabled": "IMC7nq_disabled",
  "outOfStock": "IMC7nq_outOfStock",
  "quantityPicker": "IMC7nq_quantityPicker",
  "selected": "IMC7nq_selected",
});
